import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ProductCard from "../ProductComponent/ProductCard";
import Carousel from "./Carousel";
import Footer from "../NavbarComponent/Footer";
import { API_BASE_URL } from "../config"; // Ajusta la ruta relativa según la ubicación del archivo

const HomePage = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [tempSearchText, setTempSearchText] = useState("");

  useEffect(() => {
      const fetchData = async () => {
        try {
          let response;

          if (categoryId == null && searchText === "") {
            // Fetch all products
            response = await axios.get(
              `${API_BASE_URL}/api/product/fetch/all?status=Available`
            );
          } else if (searchText) {
            // Fetch products by name
            response = await axios.get(
              `${API_BASE_URL}/api/product/search?productName=${searchText}`
            );
          } else {
            // Fetch products by category
            response = await axios.get(
              `${API_BASE_URL}/api/product/fetch/category-wise?categoryId=${categoryId}`
            );
          }
          if (response.data) {
            setProducts(response.data.products);
          }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [categoryId, searchText]);

  const searchProducts = (e) => {
    e.preventDefault();
    setSearchText(tempSearchText);
  };

  return (
    <div className="container-fluid mb-2">
      <Carousel />

      <div className="d-flex aligns-items-center justify-content-center mt-5">
        <form class="row g-3 search-panel">
          <div class="col-auto">
            <input
              type="text"
              class="form-control"
              id="inputPassword2"
              placeholder="Ingrese nombre del producto..."
              onChange={(e) => setTempSearchText(e.target.value)}
              style={{
                width: "350px",
              }}
              value={tempSearchText}
              required
            />
          </div>
          <div class="col-auto">
            <button
              type="submit"
              class="btn bg-color custom-bg-text mb-3"
              onClick={searchProducts}
            >
              Buscar
            </button>
          </div>
        </form>
      </div>

      <div className="col-md-12 mt-3 mb-5">
        <div className="row row-cols-1 row-cols-md-4 g-4">
          {products.map((product) => {
            return <ProductCard item={product} key={product.id} />;
          })}
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default HomePage;
